import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import {object, string} from 'prop-types';

import formatArea, {localizationMap} from '@explorer/util/format-area';
import {getAreaUnits} from '@explorer/selectors/measurements';
import {getSearchGeometryGeoJson} from '@explorer/selectors/search';

const AreaIndicator = ({geometry, units}) => {
  if (!geometry) {
    return '';
  } else {
    const area = formatArea(geometry, units, '0,0.[000]');
    return localizationMap[units] ? (
      <Trans i18nKey={localizationMap[units]} values={{area}} />
    ) : null;
  }
};

AreaIndicator.propTypes = {
  geometry: object,
  units: string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  geometry: ownProps.geometry || getSearchGeometryGeoJson(state),
  units: getAreaUnits(state),
});

export default connect(mapStateToProps)(AreaIndicator);
